import {
  headersMiddleware,
  overrideMiddleware,
} from '@aspectus/resource'

import { getCookie } from '@utils/cookies'

export const HEADERS_MIDDLEWERE = headersMiddleware(overrideMiddleware({
  'X-Requested-With': 'XMLHttpRequest',
  // cookie може зʼявитися пізніше за імпорт модуля — fallback на window.csrfToken,
  // який рендериться в base layout (injection.pug) у HTML до завантаження бандла
  'X-CSRFToken': getCookie('csrftoken') || window.csrfToken,
  'Accept-Language': window.language,
}))
